<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body px-3 pt-0 pb-2 min-vh-50">
              <form id="search" class="mt-3" @submit.prevent="getBill(reset)">
                <div class="row g-2 d-flex justify-content-end">
                  <div class="col-12 col-sm">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Bill Number</label>
                    <div class="input-group input-group-sm">
                      <span class="input-group-text" id="basic-addon1">
                        <i class="fa fa-search"></i>
                      </span>
                      <input v-model="search.bill_number" type="text" class="form-control" placeholder="Bill Number" aria-label="Bill Number" aria-describedby="basic-addon1">
                    </div>
                  </div>
                  <div class="col-12 col-sm-4">
                    <label class="text-xxs font-weight-normal text-secondary" for="name">Bill Date</label>
                    <Datepicker 
                      v-model="search.bill_date" 
                      range
                      format="dd MMM yyyy"/>
                  </div>
                  <div class="col-12 col-sm-1 align-self-end">
                    <button type="submit" class="btn btn-sm btn-primary mb-0">
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                </div>
              </form>
              <hr class="my-2"/>
              <div class="d-flex justify-content-end">
                <p class="align-self-center text-xs text-secondary">{{ current_page }} - {{ current_total_data }} / {{ total_data }}</p>
                <argon-pagination color="gradient-primary" size="sm">
                  <argon-pagination-item
                  @click="prevPage"
                    prev
                    :disabled="offset === 0 ? true : false" />
                  <argon-pagination-item
                    @click="nextPage"
                    next
                    :disabled="record_more === false ? true : false" />
                </argon-pagination>
              </div>
              <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr class="bg-light">
                      <th class="text-uppercase text-xxs fw-bolder">Bill No.</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Vendor Invoice Date</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Invoice Received Date</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Bill Reference</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Total Amount</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Status Bill</th>
                      <th
                        class="text-uppercase text-xxs fw-bolder ps-2"
                      >Payment Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="bill in bill_list" :key="bill.move_id">
                      <td>
                          <router-link :to="'/vendor-bill/' + bill.move_id" class="text-xs text-primary fw-bold mb-0 ps-3">
                            {{ bill.name }}
                          </router-link>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ bill.vendor_invoice_date }}</p>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ bill.invoice_date }}</p>
                      </td>
                      <td>
                        <p class="text-xs mb-0">{{ bill.ref }}</p>
                      </td>
                      <td class="align-middle">
                        <span class="text-secondary text-xs">{{ bill.amount_total }}</span>
                      </td>
                      <td class="align-middle text-sm">
                        <argon-badge color="primary" class="align-self-center" size="sm" v-if="bill.state_value == 'posted'">{{ bill.state }}</argon-badge>
                        <argon-badge color="secondary" class="align-self-center" size="sm" v-else>{{ bill.state }}</argon-badge>
                      </td>
                      <td class="align-middle text-sm">
                        <argon-badge color="danger" class="align-self-center" size="sm" v-if="bill.payment_state === 'Not Paid'">{{ bill.payment_state }}</argon-badge>
                        <argon-badge color="success" class="align-self-center" size="sm" v-else>{{ bill.payment_state }}</argon-badge>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <empty-state v-if="!bill_list.length > 0 && !loading"/>
              <loading-state v-if="loading == true"/>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonBadge from "@/components/ArgonBadge.vue";
import EmptyState from "./components/EmptyState.vue";
import LoadingState from "./components/LoadingState.vue";
const endpoint = require("../router/endpoint");
export default {
    name: 'Vendor Bills',
    components: {
      ArgonPagination,
      ArgonPaginationItem,
      ArgonBadge,
      EmptyState,
      LoadingState,
    },
    data () {
      return {
        loading: false,
        total_data: 0,
        current_total_data: 0,
        current_page: 0,
        offset: 0,
        record_more: false,
        search: {
          bill_number: null,
          bill_date: [],
        },
        bill_list: [],
      }
    },
    methods: {
      prevPage() {
      if (this.offset > 0) {
          this.offset = this.offset - 10
          this.getBill()
        }
      },
      nextPage() {
        if (this.record_more === true) {
          this.offset = this.offset + 10
          this.getBill()
        }
      },
      getDate(daterange) {
      var dateList = []
      if (daterange !== null){
        if (daterange.length > 0) {
          daterange.forEach(date => {
            if (date) {
              let month = date.getMonth() >= 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
              let fullDate = date.getFullYear() + '-' + month + '-' + date.getDate()
              dateList.push(fullDate)
            }
          });
        }
      }
      return dateList
    },
      getBill() {
        this.loading = true
        this.bill_list = []
        this.total_data = 0
        this.current_total_data = 0
        this.record_more = false
        this.current_page = 0
        let bill_date = this.getDate(this.search.bill_date)
        let offset = 0
        if (bill_date.length > 0 || this.search.bill_number) {
          offset = 0
        } else {
          offset = this.offset
        }
        this.axios
        .post(
          endpoint.BILL_LIST,
          {
            name: this.search.bill_number || '',
            date_from: bill_date.length > 0 ? bill_date[0] : '',
            date_to: bill_date.length > 1 ? bill_date[1] : '',
            partner_id: parseInt(localStorage.getItem('partner_id')),
            limit: 10,
            offset: offset
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }
        )
        .then((response) => {
          if (response.data.msg_status === "0002"){
              this.$notify({
                type: 'warn',
                title: 'Expired',
                text: 'Session expired, please sign in again.',
              });
              this.$router.replace('/signin')
              return false
          } else if (response.data.response_code === "0000") {
            this.bill_list = response.data.data;
            this.total_data = response.data.total_data
            this.current_total_data = response.data.current_total_data
            this.record_more = response.data.record_more
            this.current_page = response.data.current_page
            this.loading = false
          } else {
            if (response.data.response_code !== "4000"){
              this.$notify({
                type: 'error',
                title: 'Warning',
                text: response.data.message,
              });
            }
            this.loading = false
          }
        })
        .catch((e) => {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: e.response.data.message || e,
          });
          this.loading = false
        });
      }
    },
    mounted() {
      this.getBill()
    }
}
</script>

<style>

</style>